export default [
  {
    key: 'agent',
    name: '代理商',
    type: 'dimension',
    branches: [
      {
        key: 'agent_id',
        name: '代理商ID',
        trunk: 'agent',
      },
      {
        key: 'agent_name',
        name: '代理商名称',
        trunk: 'agent',
      },
    ],
  },
  {
    key: 'agent_type',
    name: '代理商类型',
    type: 'dimension',
    chartProportion: true,
  },
  {
    key: 'account',
    name: '广告主',
    type: 'dimension',
    branches: [
      {
        key: 'account_id',
        name: '广告主ID',
        trunk: 'account',
      },
      {
        key: 'account_name',
        name: '广告主名称',
        trunk: 'account',
      },
    ],
  },
  {
    key: 'account_type',
    name: '广告主类型',
    type: 'dimension',
  },
  {
    key: 'media_type',
    name: '媒体类型',
    type: 'dimension',
    chartProportion: true,
  },
  {
    key: 'adslot_type',
    name: '栏位类型',
    type: 'dimension',
    chartProportion: true,
  },
  {
    key: 'idea_type',
    name: '创意类型',
    type: 'dimension',
  },
  {
    key: 'is_ocpc',
    name: '是否开启OCPC',
    type: 'dimension',
  },
  {
    key: 'sale',
    name: '渠道销售',
    type: 'dimension',
    branches: [
      {
        key: 'sale_id',
        name: '渠道销售ID',
        trunk: 'sale',
      },
      {
        key: 'sale_name',
        name: '渠道销售',
        trunk: 'sale',
      },
    ],
  },
  {
    key: 'direct_sale',
    name: '直客销售',
    type: 'dimension',
    branches: [
      {
        key: 'direct_sales_id',
        name: '直客销售ID',
        trunk: 'direct_sale',
      },
      {
        key: 'direct_sales_name',
        name: '直客销售',
        trunk: 'direct_sale',
      },
    ],
  },
  {
    key: 'product',
    name: '产品名称',
    type: 'dimension',
    branches: [
      {
        key: 'product_id',
        name: '产品ID',
        trunk: 'product',
      },
      {
        key: 'product_name',
        name: '产品名称',
        trunk: 'product',
      },
    ],
  },
  {
    key: 'app_marketing_type',
    name: '营销场景',
    type: 'dimension',
    chartProportion: true,
  },
  {
    key: 'category',
    name: '行业分级',
    isShow: false,
    type: 'dimension',
    chartProportion: true,
    branches: [
      {
        key: 'category_one',
        name: '一级',
        trunk: 'category',
      },
      {
        key: 'category_two',
        name: '二级',
        trunk: 'category',
      },
      {
        key: 'category_three',
        name: '三级',
        trunk: 'category',
      },
    ],
  },
  {
    key: 'resource_type',
    name: '素材类型',
    type: 'dimension',
    branches: [
      {
        key: 'online_resources_image_num',
        name: '在线素材数-图片',
        trunk: 'resource_type',
      },
      {
        key: 'online_resources_video_num',
        name: '在线素材数-视频',
        trunk: 'resource_type',
      },
      {
        key: 'new_resources_image_num',
        name: '新增素材数-图片',
        trunk: 'resource_type',
      },
      {
        key: 'new_resources_video_num',
        name: '新增素材数-视频',
        trunk: 'resource_type',
      },
    ],
  },
];
